// Define the form type to match ContactFiltersForm
export interface ContactPageForm {
  search: string;
  employeeNumber: string;
  employeeName: string;
  occupation: string;
  extension: string;
  email: string;
  mobile: string;
  workLocation: string;
  department: string;
  departmentType?: 'department' | 'project';
}

// default values for dropdowns
export const initialValuesFilterForm: ContactPageForm = {
  search: '',
  employeeNumber: '',
  employeeName: '',
  occupation: '',
  extension: '',
  email: '',
  mobile: '',
  workLocation: 'all', // Set to 'all' instead of empty string
  department: '', // Set to empty string instead of 'all'
  departmentType: undefined,
};
